import { useQuery } from '@tanstack/react-query';
import { fetchFees } from '../services/smr-admin';
import type { SimpleListParams } from '../services/smr-admin';

export const feeKeys = {
    all: ['smr-admin', 'fees'] as const,
    lists: () => [...feeKeys.all, 'list'] as const,
    list: (params: SimpleListParams) => [...feeKeys.lists(), params] as const,
    detail: (id: string) => [...feeKeys.all, 'detail', id] as const,
};

export const useFeesQuery = (params: SimpleListParams = {}) =>
    useQuery({
        queryKey: feeKeys.list(params),
        queryFn: () => fetchFees(params),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
